import React, { useState, useRef, useEffect, Suspense } from 'react';
import { Flex, Box, Image, Button, Text, useDisclosure } from '@chakra-ui/react';

const Navbar = () => {
  return (
    <Flex gap="10px" 
      position="absolute"
      w="100%" 
      zIndex="9" 
      mt="110px"
      p="0px 30px 0px 30px" 
      top="0" 
      justifyContent="space-between"
      className="navbar"
      h="10px" 
      w="100%">

    </Flex>
  );
};

export default Navbar;